import { render, staticRenderFns } from "./OmniErrorMessage.vue?vue&type=template&id=6b5e852c&scoped=true&"
import script from "./OmniErrorMessage.vue?vue&type=script&lang=js&"
export * from "./OmniErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e852c",
  null
  
)

export default component.exports